module.exports = __webpack_public_path__ + "static/img/222.128.59.137.57369385.png";